import dayjs from 'dayjs';
import { LatestLoan } from '@/hooks/providers/useLatestLoanProvider';
import { WithdrawDataDatetype } from '@/hooks/webapi/client/useWithdrawQuery';

export const isWithdrawFlowDone = (
  latestLoan: LatestLoan | null | undefined,
  withdrawDataDate?: WithdrawDataDatetype | null | undefined,
) =>
  latestLoan?.enhancements.includes('CONTRACT_WITHDRAWAL') ||
  Boolean(withdrawDataDate?.withdrawalDate);

export const withdrawDaysDiff = (
  withdrawDataDate: WithdrawDataDatetype | null | undefined,
) => dayjs(dayjs()).diff(withdrawDataDate?.withdrawalDate, 'day');
